{
    "checkout": {
        "billing_address": {
            "title": "Factuuradres"
        },
        "delivery": {
            "delivery_date_info": "Je pakket wordt uiterlijk bij je thuis bezorgd op ",
            "info": "Voer je bezorgadres in om de beschikbare verzendmethodes te zien",
            "preferences": {
                "express": {
                    "description": "Vandaag besteld, overmorgen al bezorgd!",
                    "label": "Spoed levering"
                },
                "label": "Welke bezorging heeft je voorkeur?",
                "regular": {
                    "label": "Normale levering"
                }
            },
            "title": "Bezorging"
        },
        "form": {
            "address_finder": {
                "address_filled": "Je adres is automatisch ingevuld.",
                "invalid_address": "Het opgegeven adres is niet gevonden. Controleer je invoer en probeer opnieuw.",
                "label": "Adreszoeker",
                "placeholder": "Begin met typen om je adres te zoeken",
                "select_address": "Selecteer je adres uit de lijst."
            },
            "city": {
                "label": "Woonplaats",
                "placeholder": "Woonplaats",
                "invalid_characters": "Gebruik alleen letters, spaties, koppeltekens (-) en apostrofs ('), maximaal 100 tekens."
            },
            "company": {
                "label": "Bedrijfsnaam",
                "placeholder": "Bedrijfsnaam"
            },
            "country": {
                "label": "Land"
            },
            "email": {
                "label": "E-mailadres",
                "placeholder": "E-mailadres",
                "label_track_trace": "E-mailadres voor track & trace"
            },
            "first_name": {
                "label": "Voornaam",
                "placeholder": "Voornaam"
            },
            "house_number": {
                "label": "Huisnummer",
                "placeholder": "Bijv. 1"
            },
            "house_number_suffix": {
                "label": "Toevoeging",
                "placeholder": "Bijv. A"
            },
            "order_type": {
                "corporate": {
                    "label": "Zakelijk"
                },
                "private": {
                    "label": "Particulier"
                },
                "title": "Type bestelling"
            },
            "phone_number": {
                "label": "Telefoonnummer",
                "placeholder": "Telefoonnummer",
                "invalid_characters": "Gebruik alleen cijfers, spaties en + - ( ), maximaal 20 tekens."
            },
            "same_address": {
                "label": "Factuur- en verzendadres zijn hetzelfde"
            },
            "street_name": {
                "label": "Straatnaam",
                "placeholder": "Straatnaam"
            },
            "surname": {
                "label": "Achternaam",
                "placeholder": "Achternaam"
            },
            "vat_number": {
                "label": "BTW nummer",
                "placeholder": "BTW nummer"
            },
            "zipcode": {
                "label": "Postcode",
                "placeholder_example": "Bijv. {example}",
                "invalid": "Vul een geldige postcode in, zoals {example}."
            },
            "save_in_address_book": {
                "label": "Opslaan in adresboek"
            },
            "newsletter_subscribe": {
                "label": "Houd me op de hoogte van nieuws, inspiratie en exclusieve aanbiedingen per e-mail"
            },
            "account_type": {
                "title": "Account",
                "guest": {
                    "label": "Doorgaan als gast"
                },
                "create": {
                    "label": "Account aanmaken"
                },
                "email_taken": "Er bestaat al een account met dit e-mailadres.",
                "login_link": "Log in",
                "password_required": "Vul twee keer hetzelfde wachtwoord in om je account aan te maken.",
                "privacy_required": "Je moet akkoord gaan met de Privacy verklaring om je account aan te maken."
            }
        },
        "payment": {
            "ideal_wero": {
                "description": "iDEAL {'|'} Wero"
            },
            "paypal": {
                "description": "Paypal"
            },
            "title": "Betaalmethodes"
        },
        "shipping_address": {
            "title": "Bezorgadres"
        },
        "customer_addresses": {
            "add_new": "Nieuw adres toevoegen",
            "create_modal_title": "Nieuw adres",
            "edit_modal_title": "Adres bewerken",
            "delete_modal_title": "Adres verwijderen"
        },
        "address_book": {
            "add_new": "Nieuw adres toevoegen",
            "default_billing": "Standaard factuuradres",
            "default_shipping": "Standaard verzendadres",
            "create_modal": {
                "title_shipping": "Nieuw bezorgadres",
                "title_billing": "Nieuw factuuradres",
                "confirm": "Opslaan",
                "cancel": "Annuleren"
            },
            "edit_modal": {
                "title": "Adres bewerken",
                "confirm": "Opslaan",
                "cancel": "Annuleren"
            },
            "delete_modal": {
                "title": "Adres verwijderen",
                "confirm": "Verwijderen",
                "cancel": "Annuleren",
                "description": "Weet je zeker dat je dit adres wilt verwijderen? Dit kan niet ongedaan worden gemaakt."
            },
            "save_failed": "Opslaan mislukt. Probeer het opnieuw.",
            "delete_failed": "Verwijderen mislukt. Probeer het opnieuw.",
            "order_only": "Alleen voor deze bestelling"
        }
    },
    "components": {
        "buttons": {
            "default": {
                "add_to_cart": {
                    "label": "In winkelwagen"
                },
                "back": {
                    "label": "Terug"
                },
                "cancel": {
                    "label": "Annuleer"
                },
                "close": {
                    "label": "Sluiten"
                },
                "confirm": {
                    "label": "Bevestig"
                },
                "delete": {
                    "label": "Verwijder"
                },
                "edit": {
                    "label": "Bewerk"
                },
                "next": {
                    "label": "Volgende"
                },
                "previous": {
                    "label": "Vorige"
                },
                "proceed_configuration": {
                    "label": "Doorgaan met bestellen"
                },
                "save": {
                    "label": "Opslaan"
                },
                "start_ordering": {
                    "label": "Begin met bestellen"
                },
                "upload_photo": {
                    "label": "Foto uploaden"
                }
            },
            "previous_page": {
                "label": "Vorige pagina"
            },
            "close": {
                "label": "Sluiten"
            }
        },
        "discount_blocks": {
            "code_copied": "Code gekopieerd!"
        },
        "dropdown": {
            "menu_button": {
                "label": "Menu"
            }
        },
        "footer": {
            "newsletter": {
                "title": "Mis nooit meer een aanbieding",
                "subtitle": "Schrijf je in voor onze nieuwsbrief",
                "email_label": "E-mailadres",
                "submit_button": "Verstuur"
            }
        },
        "header": {
            "all_categories_line_1": "Bekijk alle",
            "all_categories_line_2": "categorieën",
            "search_aria_label": "Zoeken",
            "search_close_aria_label": "Zoeken sluiten",
            "search_placeholder": "Waar ben je naar op zoek?",
            "search_all_designs_title": "Alle designs voor ‘{query}’",
            "search_all_designs_label": "designs",
            "search_suggestions_title": "Zoeksuggesties",
            "search_products_title": "Producten",
            "search_no_results_title": "Geen designs voor ‘{query}’",
            "search_no_results_hint": "Controleer de spelling of probeer een breder woord.",
            "search_scope_all_products": "Alle producten",
            "search_scope_products": "Product…",
            "search_all_designs_title_scoped": "Alle designs voor ‘{query}’ in {group}",
            "search_scope_reset": "Zoek ‘{query}’ in alle producten",
            "search_popular_on_title": "Populair op {name}",
            "search_categories_title": "Categorieën"
        },
        "layouts": {
            "login_status": {
                "cart": {
                    "label": "Winkelwagen"
                },
                "login": {
                    "label": "Inloggen"
                },
                "welcome": {
                    "label": "Welkom,"
                },
                "welcome_back": {
                    "label": "Welkom terug"
                }
            },
            "mobile_menu_button": {
                "label": "Menu"
            },
            "mobile_menu_drawer": {
                "back_to_categories": "Terug naar alle categorieën",
                "close": "Sluit menu",
                "default_title": "Menu",
                "view_all": "Bekijk alles van {title}",
                "expand_submenu": "Submenu uitklappen"
            }
        },
        "select_menus": {
            "default": {
                "placeholder": "Selecteer optie"
            }
        },
        "spinners": {
            "default": {
                "label": "Laden..."
            }
        },
        "header_slider": {
            "timer": {
                "days": "d",
                "hours": "u",
                "minutes": "m",
                "seconds": "s"
            }
        },
        "modals": {
            "register": {
                "has_account": "Al een account?",
                "general_error": "Registreren is mislukt. Probeer het opnieuw."
            },
            "login": {
                "title": "Inloggen"
            }
        },
        "wishlist": {
            "button": {
                "add_aria_label": "Toevoegen aan verlanglijst",
                "remove_aria_label": "Verwijderen uit verlanglijst"
            },
            "header_button": {
                "aria_label": "Verlanglijst"
            },
            "toast": {
                "removed": "Verwijderd uit je verlanglijst",
                "undo": "Ongedaan maken"
            },
            "guest_added": {
                "title": "Verlanglijst",
                "success": "Toegevoegd aan je verlanglijst",
                "login_prompt": "{login} of {register} om je verlanglijst op al je apparaten te bewaren en te delen.",
                "login": "Log in",
                "register": "maak een account aan",
                "continue_shopping": "Verder winkelen",
                "view_wishlist": "Bekijk verlanglijst"
            }
        },
        "related_products": {
            "title": "Kies je design",
            "show_all": "Bekijk alle",
            "show_less": "Minder tonen",
            "section_title": "Ontdek meer uit deze collectie"
        },
        "same_kind_products": {
            "title": "Deze vind je vast ook leuk"
        },
        "same_print_products": {
            "title": "Deze print op meer producten"
        },
        "pdp_steps": {
            "step_label": "Stap {number}"
        },
        "pdp_review_videos": {
            "play_label": "Videobeoordeling van {name} afspelen"
        },
        "video": {
            "play_label": "Video afspelen"
        },
        "slider": {
            "go_to_item": "Ga naar item {index} van {total}"
        },
        "lightbox": {
            "counter": "{current} van {total}"
        },
        "share": {
            "copy": "Kopieer link",
            "copied": "Link gekopieerd",
            "more": "Meer",
            "sms": "Berichten",
            "email": "E-mail"
        }
    },
    "general": {
        "checkout": {
            "title": "Afrekenen"
        },
        "delivery_options": {
            "day_after_tomorrow": {
                "label": "Vandaag besteld, <b>overmorgen</b> in huis!"
            },
            "delivered_in_days": {
                "label": "Binnen <b>{days} dagen</b> in huis"
            },
            "delivered_in_business_days": {
                "label": "Vandaag besteld, binnen {days} werkdag in huis! | Vandaag besteld, binnen {days} werkdagen in huis!"
            },
            "today_delivery": {
                "label": "Vandaag besteld, <b>vandaag</b> in huis!"
            },
            "tomorrow_delivery": {
                "label": "Vandaag besteld, <b>morgen</b> in huis!"
            }
        },
        "password": {
            "confirmation": {
                "label": "Bevestig wachtwoord"
            },
            "confirmation_new": {
                "label": "Bevestig nieuw wachtwoord"
            },
            "current": {
                "label": "Huidig wachtwoord"
            },
            "label": "Wachtwoord",
            "mismatch": "De wachtwoorden komen niet overeen, controleer de velden nogmaals.",
            "new": {
                "label": "Nieuw wachtwoord"
            },
            "requirements": "Gebruik 3 verschillende tekens in het wachtwoord. Mogelijke karakters: kleine letters, hoofdletters, cijfers en speciale tekens."
        },
        "price_tables": {
            "entries": {
                "amount_label": "1 stuk | {count} stuks",
                "all_sizes": "Alle maten"
            },
            "title": {
                "amount": "Aantal",
                "size": "Grootte"
            }
        },
        "prices": {
            "excl_discount": {
                "label": "Prijs excl. korting"
            },
            "for": {
                "label": "Voor"
            },
            "from": {
                "label": "Van"
            },
            "starting_from": {
                "label": "Vanaf"
            },
            "title": "Prijzen",
            "total": {
                "label": "Totaal"
            }
        },
        "product_description": {
            "title": "Product omschrijving"
        },
        "question_and_answers": {
            "no_data": {
                "primary_text": "Er zijn geen vragen en antwoorden gevonden."
            },
            "title": "Vragen en antwoorden",
            "subtitle": "Wat klanten het vaakst vragen."
        },
        "reviews": {
            "buyer": "Koper",
            "customer_images": "Afbeeldingen van klanten",
            "view_more_images": "Bekijk meer",
            "filter_all_stars": "Alles tonen",
            "filter_label": "Filter",
            "filter_stars": "1 ster | {count} sterren",
            "highest_rated_title": "Klantreviews",
            "no_reviews_title": "Nog geen geschreven reviews",
            "no_reviews_description": "Er is 1 beoordeling met {rating} sterren. | Er zijn {votes} beoordelingen met gemiddeld {rating} sterren.",
            "image_alt": "Reviewafbeelding",
            "no_results_for_filter": "Er zijn geen reviews voor dit filter.",
            "read_full_review": "Lees hele review",
            "review_amount": "{count} Beoordeling | {count} Beoordelingen",
            "review_count": "{votes} Beoordelingen waarvan {reviewCount} geschreven",
            "show_all_reviews": "Toon alle {count} klantreviews",
            "show_less": "Toon minder",
            "show_original": "Dit is een vertaling, origineel weergeven",
            "show_star_reviews": "Toon {score}-ster reviews",
            "show_translation": "Vertaling weergeven",
            "title": "Beoordelingen",
            "about": "Over:",
            "read_more": "Lees meer",
            "show_all": "Toon alle {count}",
            "votes_count": "1 beoordeling | {count} beoordelingen"
        },
        "shipping_options": {
            "title": "Bezorgopties"
        },
        "show_more_products": "Meer producten tonen",
        "stock": {
            "available": "Direct uit voorraad leverbaar"
        },
        "filter_amount_products": "Filter {count} producten",
        "pickup_points": {
            "pickup_location": {
                "confirmed": "Afhaalpunt geselecteerd!",
                "select": "Hier ophalen"
            }
        },
        "price_table": {
            "filters": {
                "show_less": "Minder formaten weergeven",
                "show_more": "Meer formaten weergeven"
            }
        },
        "show_less_collections": "Bekijk minder collecties",
        "show_more_collections": "Bekijk meer collecties",
        "show_more": "Toon meer",
        "show_less": "Toon minder",
        "product_details": "Productinformatie"
    },
    "pages": {
        "cart_page": {
            "add_product": "Nog een product toevoegen",
            "coupon_applied": "Kortingscode toegepast.",
            "coupon_apply_failed": "Het toepassen van de code is niet gelukt. Probeer het nog eens.",
            "free_shipping_remaining": "Nog {amount} tot {free}",
            "free_shipping_goal": "gratis verzending",
            "free_shipping_exception": "Uitgezonderd XXL-pakketten",
            "no_items_proceed_shopping_link": "hier",
            "overview_title": "Overzicht",
            "pages_count": "{count} pagina's",
            "quantity_update_failed": "Aantal kan niet worden bijgewerkt.",
            "remove_modal": {
                "cancel": "Annuleer",
                "confirm": "Weet je zeker dat je dit product uit je winkelwagen wilt verwijderen?",
                "set_confirm": "Als je dit product verwijdert, vervalt de setkorting op de overige producten. Weet je zeker dat je het wilt verwijderen?",
                "title": "Product verwijderen",
                "yes": "Ja, verwijder"
            },
            "cart_item": {
                "delete": "Verwijder",
                "edit": "Bewerk",
                "edit_failed": "Het product kon niet worden geopend om te bewerken. Probeer het opnieuw.",
                "quantity": {
                    "label": "Aantal"
                },
                "set_count": "{count} product | {count} producten",
                "show_details": "Details tonen"
            },
            "messages": {
                "success": {
                    "deleted": "Het product is uit je winkelwagen verwijderd."
                }
            },
            "no_items": "Je hebt geen product(en) in je winkelwagen.",
            "overview": {
                "coupon_code": {
                    "button": {
                        "label": "Pas toe"
                    },
                    "cancel": "Annuleer",
                    "input": {
                        "placeholder": "Voer kortingscode in"
                    },
                    "title": "Kortingscode invoeren"
                },
                "coupon_code_display": "Kortingscode ({code})",
                "coupon_codes_display": "Kortingcodes",
                "discount_display": "Korting",
                "item_count": "1 artikel | {count} artikelen",
                "prices": {
                    "discount": "Je bespaart",
                    "grand_total": "Totaal",
                    "shipping": "Verzending",
                    "subtotal": "Subtotaal",
                    "tax": "BTW",
                    "tax_included": "incl. {amount} btw",
                    "total_incl_tax": "Totaal (incl. BTW)"
                }
            },
            "proceed_to_checkout": "Ik ga bestellen",
            "title": "Winkelwagen",
            "no_items_proceed_shopping": "Klik {link} om verder te winkelen.",
            "free_shipping": "Gratis verzending",
            "free_shipping_reached": "{free} voor je bestelling",
            "checkout_hint": "Hierna: adres en bezorgmoment kiezen"
        },
        "category": {
            "filters_title": "Filteren",
            "clear_all": "Wis alles",
            "selected_count": "{count} gekozen",
            "selected_filters": "Gekozen filters",
            "hierarchy_all": "Alle {label}",
            "close_filters": "Sluit filters",
            "no_filter_options_available": "Geen filteropties beschikbaar",
            "no_image": "Geen afbeelding",
            "open_grid_view": "Open rasterweergave",
            "open_list_view": "Open lijstweergave",
            "open_two_column_view": "Open weergave met 2 kolommen",
            "products": {
                "label": "producten",
                "prices": {
                    "recommended_price": "anders"
                }
            },
            "remove_filter": "Verwijder filter {filter}: {value}",
            "show_results": "Toon resultaten",
            "show_results_with_count": "Toon {count} resultaten",
            "clear_filters": "Verwijder alle filters",
            "filter": "Filter",
            "show_less_filters": "Bekijk minder",
            "show_more_filters": "Bekijk meer",
            "faqs": {
                "title": "Veelgestelde vragen"
            },
            "header": {
                "header_description": {
                    "show_more": "Meer",
                    "show_less": "Minder"
                }
            },
            "filter_explanation": "Meer informatie over dit filter"
        },
        "collection": {
            "delivery_options": {
                "pickup_point": "Afhaalpunt (duurzame keuze)"
            }
        },
        "customers": {
            "dashboard": {
                "account_information": {
                    "form": {
                        "assistance_allowed_label": "Toestaan van hulp op afstand bij het winkelen",
                        "assistance_allowed_tooltip": "Hiermee kunnen medewerkers meekijken en namens jou handelingen uitvoeren om je beter te helpen tijdens het winkelen.",
                        "email_label": "E-mailadres",
                        "first_name_label": "Voornaam",
                        "last_name_label": "Achternaam",
                        "legend": "Accountinformatie",
                        "submit_button": "Opslaan"
                    },
                    "index": {
                        "intro": "Mijn contactgegevens en accountinstellingen.",
                        "title": "Accountinformatie"
                    }
                },
                "address": {
                    "billing_title": "Standaard factuuradres",
                    "description": "Huidig standaard factuur- en verzendadres.",
                    "legend": "Adresboek",
                    "manage_link": "Beheer adressen",
                    "shipping_title": "Standaard verzendadres"
                },
                "addresses": {
                    "create": {
                        "intro": "Voeg een nieuw adres toe aan het adresboek.",
                        "title": "Nieuw adres"
                    },
                    "default_cards": {
                        "empty_state": "Nog geen standaardadres ingesteld."
                    },
                    "edit": {
                        "intro": "Bewerk een bestaand adres uit het adresboek.",
                        "title": "Adres bewerken"
                    },
                    "form": {
                        "address_legend": "Adres",
                        "city_label": "Plaatsnaam",
                        "company_label": "Bedrijf",
                        "contact_legend": "Contactgegevens",
                        "countries": {
                            "AT": "Oostenrijk",
                            "BE": "Belgie",
                            "DE": "Duitsland",
                            "FR": "Frankrijk",
                            "LU": "Luxemburg",
                            "NL": "Nederland"
                        },
                        "country_label": "Land",
                        "default_billing_label": "Gebruik als standaard factuuradres",
                        "default_shipping_label": "Gebruik als standaard verzendadres",
                        "first_name_label": "Voornaam",
                        "last_name_label": "Achternaam",
                        "postcode_label": "Postcode",
                        "region_label": "Staat/Provincie",
                        "street1_label": "Adres",
                        "street2_label": "Adresregel 2",
                        "submit_create_button": "Adres toevoegen",
                        "submit_edit_button": "Adres opslaan",
                        "telephone_label": "Telefoonnummer"
                    },
                    "index": {
                        "add_address_button": "Adres toevoegen",
                        "billing_action_text": "Verander factuuradres",
                        "billing_title": "Standaard factuuradres",
                        "delete_modal_cancel_button": "Annuleren",
                        "delete_modal_confirm_button": "Verwijderen",
                        "delete_modal_description": "Weet je zeker dat je dit adres wilt verwijderen?",
                        "delete_modal_title": "Adres verwijderen",
                        "intro": "Mijn adressen en aanvullende gegevens.",
                        "shipping_action_text": "Verander verzendadres",
                        "shipping_title": "Standaard verzendadres",
                        "title": "Adresboek"
                    },
                    "list": {
                        "address_column": "Adres",
                        "city_column": "Plaats",
                        "company_column": "Bedrijf",
                        "country_column": "Land",
                        "delete_label": "Verwijder",
                        "edit_title": "Bewerk",
                        "empty_state": "Er zijn nog geen overige adressen ingesteld.",
                        "legend": "Overige adressen",
                        "name_column": "Naam"
                    }
                },
                "empty_address_state": "Er is nog geen adres ingesteld.",
                "intro": "Welkom {firstName}! Onderstaand vind je al je informatie en recente bestellingen terug.",
                "navigation": {
                    "account_information": "Accountinformatie",
                    "address_book": "Adresboek",
                    "dashboard": "Dashboard",
                    "logout": "Uitloggen",
                    "orders": "Mijn bestellingen",
                    "projects": "Mijn fotoboeken",
                    "security": "Beveiliging",
                    "title": "Mijn account",
                    "wishlist": "Verlanglijst"
                },
                "wishlist": {
                    "index": {
                        "title": "Verlanglijst",
                        "intro": "Producten die je hebt opgeslagen.",
                        "legend": "Mijn verlanglijst",
                        "empty_state": "Je verlanglijst is leeg.",
                        "guest_notice": "Opgeslagen op dit apparaat · {login} om je items overal te zien",
                        "guest_notice_login": "Log in"
                    },
                    "share": {
                        "button": "Delen",
                        "title": "Deel je verlanglijst met anderen",
                        "description": "Iedereen met deze link kan je verlanglijst bekijken."
                    },
                    "shared": {
                        "title": "Gedeelde verlanglijst",
                        "intro": "Deze producten zijn met je gedeeld."
                    }
                },
                "order_history": {
                    "detail": {
                        "header": {
                            "date_label": "Datum"
                        },
                        "index": {
                            "back_button": "Terug naar bestellingsoverzicht",
                            "intro": "Detailoverzicht van een bestelling.",
                            "title": "Bestelling # {number}"
                        },
                        "info": {
                            "billing_address_title": "Factuuradres",
                            "payment_method_title": "Betaalmethode",
                            "shipping_address_title": "Bezorgadres",
                            "shipping_method_title": "Verzendmethode"
                        },
                        "items": {
                            "article_number_label": "Art.nr.",
                            "legend": "Bestelde artikelen",
                            "price_column": "Prijs",
                            "product_name_column": "Product Naam",
                            "quantity_column": "Aantal",
                            "subtotal_column": "Subtotaal"
                        },
                        "totals": {
                            "discount": "Korting",
                            "grand_total": "Eindtotaal (incl. BTW)",
                            "grand_total_excluding_tax": "Eindtotaal (excl. BTW)",
                            "shipping": "Verzending en verwerking",
                            "subtotal": "Subtotaal",
                            "tax": "BTW"
                        }
                    },
                    "index": {
                        "intro": "Overzicht van mijn geplaatste bestellingen.",
                        "legend": "Mijn bestellingen",
                        "order_count": "{count} bestelling | {count} bestellingen",
                        "title": "Mijn bestellingen"
                    },
                    "table": {
                        "date_column": "Datum",
                        "empty_state": "Je hebt nog geen bestellingen geplaatst.",
                        "order_number_column": "Ordernr.",
                        "status_column": "Status",
                        "total_column": "Totaal",
                        "tracking_column": "Track & trace",
                        "view_label": "Bekijk"
                    }
                },
                "orders": {
                    "date_column": "Datum",
                    "empty_state": "Je hebt nog geen bestellingen geplaatst.",
                    "legend": "Recente orders",
                    "order_number_column": "Ordernr.",
                    "shipping_to_column": "Verzenden aan",
                    "status_column": "Status",
                    "total_column": "Totaal",
                    "view_all_link": "Bekijk alles",
                    "view_link": "Bekijk"
                },
                "profile": {
                    "create": {
                        "intro": "Voeg een nieuw adres toe aan het adresboek.",
                        "title": "Nieuw adres"
                    },
                    "edit": {
                        "intro": "Bewerk een bestaand adres uit het adresboek.",
                        "title": "Adres bewerken"
                    },
                    "edit_link": "Bewerk je accountinformatie",
                    "form": {
                        "address_legend": "Adres",
                        "city_label": "Plaatsnaam",
                        "company_label": "Bedrijf",
                        "contact_legend": "Contactgegevens",
                        "country_label": "Land",
                        "default_billing_label": "Gebruik als standaard factuuradres",
                        "default_shipping_label": "Gebruik als standaard verzendadres",
                        "first_name_label": "Voornaam",
                        "last_name_label": "Achternaam",
                        "postcode_label": "Postcode",
                        "region_label": "Staat/Provincie",
                        "street1_label": "Adres",
                        "street2_label": "Adresregel 2",
                        "submit_create_button": "Adres toevoegen",
                        "submit_edit_button": "Adres opslaan",
                        "telephone_label": "Telefoonnummer"
                    },
                    "legend": "Contactgegevens",
                    "list": {
                        "address_column": "Adres",
                        "city_column": "Plaats",
                        "company_column": "Bedrijf",
                        "country_column": "Land",
                        "delete_label": "Verwijder",
                        "edit_title": "Bewerk",
                        "empty_state": "Er zijn nog geen overige adressen ingesteld.",
                        "legend": "Overige adressen",
                        "name_column": "Naam"
                    }
                },
                "projects": {
                    "index": {
                        "intro": "Mijn opgeslagen projecten en fotoboeken.",
                        "legend": "Mijn fotoboeken",
                        "title": "Mijn fotoboeken"
                    },
                    "list": {
                        "actions_column": "Acties",
                        "empty_state": "Je hebt nog geen fotoboeken opgeslagen.",
                        "fallback_text": "Fotoboek voorbeeld",
                        "preview_alt": "Voorbeeld",
                        "preview_link": "Voorbeeld",
                        "product_column": "Product",
                        "project_link": "Naar project",
                        "updated_at_column": "Laatst bijgewerkt"
                    }
                },
                "security": {
                    "form": {
                        "legend": "Wachtwoord aanpassen",
                        "submit": "Wachtwoord opslaan"
                    },
                    "index": {
                        "intro": "Werk hier het wachtwoord van je account bij.",
                        "title": "Beveiliging"
                    }
                },
                "title": "Mijn account",
                "intro_no_name": "Welkom! Hieronder vind je al je informatie en recente bestellingen terug."
            },
            "login": {
                "index": {
                    "create_account": "Account aanmaken",
                    "description": "Als je een account hebt, meld je dan aan met je e-mailadres.",
                    "email_label": "E-mailadres",
                    "email_placeholder": "naam{'@'}voorbeeld.nl",
                    "forgot_password": "Wachtwoord vergeten?",
                    "intro": "Log in of maak een account aan om naar je dashboard te gaan.",
                    "legend": "Inloggen",
                    "new_customers_description": "Het aanmaken van een account heeft vele voordelen: sneller afhandelen, meer dan één adres registreren, volgen van bestellingen en meer.",
                    "new_customers_legend": "Nieuwe klanten",
                    "password_label": "Wachtwoord",
                    "password_placeholder": "Vul je wachtwoord in",
                    "submit": "Inloggen",
                    "title": "Inloggen",
                    "sso_facebook": "Doorgaan met Facebook",
                    "sso_google": "Doorgaan met Google",
                    "sso_separator": "Of"
                }
            },
            "passwords": {
                "forgot": {
                    "index": {
                        "back_button": "Terug naar inloggen",
                        "description": "Als er een account bestaat met het opgegeven e-mailadres, krijg je een e-mail.",
                        "email_label": "E-mailadres",
                        "email_placeholder": "naam{'@'}voorbeeld.nl",
                        "intro": "Voer je e-mailadres hieronder in om een wachtwoord reset link te ontvangen.",
                        "submit_button": "Verstuur",
                        "title": "Wachtwoord vergeten?"
                    }
                },
                "reset": {
                    "index": {
                        "intro": "Kies hieronder een nieuw wachtwoord voor je account.",
                        "submit": "Een nieuw wachtwoord instellen",
                        "title": "Nieuw wachtwoord instellen"
                    }
                }
            },
            "register": {
                "credentials": {
                    "email_label": "E-mailadres",
                    "legend": "Inloggegevens",
                    "privacy_link": "Privacy verklaring",
                    "privacy_prefix": "Ik ga akkoord met de"
                },
                "index": {
                    "back_button": "Terug naar inloggen",
                    "intro": "Maak een nieuw account aan om straks je bestellingen, adressen en projecten te beheren.",
                    "submit_button": "Account aanmaken",
                    "title": "Maak een nieuw account aan"
                },
                "profile": {
                    "first_name_label": "Voornaam",
                    "last_name_label": "Achternaam",
                    "legend": "Persoonlijke informatie",
                    "subscribe_label": "Aanmelden voor de nieuwsbrief"
                }
            }
        },
        "errors": {
            "back_to_home": "Terug naar de homepagina",
            "404": {
                "heading": "Pagina niet gevonden.",
                "description": "We konden de pagina niet vinden. Mogelijk is de link verlopen of is de pagina verplaatst."
            },
            "500": {
                "heading": "Er is iets misgegaan.",
                "description": "Er is een onverwachte fout opgetreden aan onze kant. Probeer het later opnieuw."
            },
            "403": {
                "heading": "Geen toegang.",
                "description": "Je hebt geen toegang tot deze pagina."
            },
            "503": {
                "heading": "Tijdelijk niet beschikbaar.",
                "description": "De website is tijdelijk niet beschikbaar. Probeer het later opnieuw."
            },
            "generic": {
                "heading": "Er is een fout opgetreden.",
                "description": "Er is een onverwachte fout opgetreden. Probeer het later opnieuw."
            }
        },
        "product_detail_page": {
            "share": {
                "label": "Deel deze pagina",
                "title": "Deel dit product met anderen"
            },
            "product_info": {
                "benefits": {
                    "title": "De voordelen van {storeName}",
                    "payment_methods_label": "betaal o.a. met"
                },
                "klarna": {
                    "loading": {
                        "label": "Klarna is aan het inladen..."
                    }
                },
                "modals": {
                    "product_options_modal": {
                        "overview": {
                            "title": "Overzicht"
                        },
                        "title": "Kies extra opties"
                    }
                },
                "product_button": {
                    "add_to_cart": {
                        "error": "Er is iets misgegaan bij het toevoegen aan de winkelwagen.",
                        "loading": {
                            "description": "Je wordt automatisch doorgestuurd.",
                            "label": "Toevoegen aan winkelwagen..."
                        },
                        "set_error": "Er is iets misgegaan bij het toevoegen van de set. Een deel kan al in je winkelwagen liggen, dus controleer je winkelwagen voordat je het opnieuw probeert."
                    },
                    "book_login_modal": {
                        "continue_without_login": "Doorgaan zonder in te loggen",
                        "continue_without_login_warning": "Als je doorgaat zonder in te loggen, worden je foto's niet opgeslagen. Je kunt je product later niet aanpassen of afronden.",
                        "description": "Log in om je voortgang op te slaan en later verder te gaan met je project.",
                        "email_label": "E-mailadres",
                        "email_placeholder": "naam{'@'}voorbeeld.nl",
                        "forgot_password": "Wachtwoord vergeten?",
                        "general_error": "Inloggen is mislukt. Controleer je gegevens en probeer opnieuw.",
                        "no_account": "Nog geen account?",
                        "password_label": "Wachtwoord",
                        "password_placeholder": "Vul je wachtwoord in",
                        "separator": "Of",
                        "submit": "Inloggen",
                        "title": "Inloggen"
                    },
                    "new_project_modal": {
                        "description": "Geef je fotoboek een titel om het later makkelijk terug te vinden. Je kunt dit altijd later wijzigen.",
                        "submit": "Beginnen",
                        "title": "Geef je project een naam",
                        "title_hint": "{count} / 150",
                        "title_label": "Projecttitel",
                        "title_placeholder": "Bijv. Vakantie {year}, Familiealbum..."
                    },
                    "recent_projects_modal": {
                        "description": "Ga verder met een bestaand fotoboekproject of start een nieuw project.",
                        "empty_state": "Je hebt nog geen recente fotoboekprojecten.",
                        "error": "Er is iets misgegaan bij het laden van je projecten.",
                        "loading": "Je recente projecten worden geladen...",
                        "next_page": "Volgende",
                        "open_error": "Het project kon niet worden geopend. Probeer opnieuw.",
                        "open_project": "Project openen",
                        "opening": "Bezig met openen...",
                        "pagination": "Pagina {page} van {total}",
                        "previous_page": "Vorige",
                        "retry": "Probeer opnieuw",
                        "sheet_count": "{count} bladzijden",
                        "start_new_project": "Nieuw project starten",
                        "title": "Recente projecten",
                        "updated_at": "Laatst bewerkt: {date}"
                    },
                    "start_ordering": {
                        "loading": {
                            "description": "We zetten de designer voor je klaar.",
                            "label": "Je product wordt voorbereid..."
                        }
                    },
                    "start_over": {
                        "confirm_modal": {
                            "cancel": "Annuleren",
                            "confirm": "Ja, opnieuw beginnen",
                            "description": "Je foto en instellingen gaan verloren. Je kunt dit niet ongedaan maken.",
                            "title": "Weet je zeker dat je opnieuw wilt beginnen?"
                        },
                        "label": "Of opnieuw beginnen, kies nieuwe foto"
                    },
                    "upload": {
                        "errors": {
                            "file_too_large": "Deze foto is te groot. Upload een afbeelding van maximaal 100 MB.",
                            "generic": "Er is iets misgegaan tijdens het uploaden. Probeer het opnieuw.",
                            "invalid_file_type": "Dit bestandstype wordt niet ondersteund. Upload een JPG-, PNG- of WebP-afbeelding.",
                            "retry_cta": "Probeer opnieuw",
                            "title": "Upload mislukt"
                        },
                        "leave_modal": {
                            "cancel": "Blijf hier",
                            "confirm": "Upload stoppen",
                            "description": "Je foto is nog aan het uploaden. Als je nu weggaat, gaat je voortgang verloren.",
                            "title": "Weet je zeker dat je wilt stoppen?"
                        },
                        "offline": {
                            "description": "Je verbinding is weggevallen. Zodra je weer online bent, gaan we verder waar we gebleven zijn.",
                            "title": "Geen verbinding"
                        },
                        "redirecting": {
                            "description": "Je wordt doorgestuurd.",
                            "label": "Upload voltooid!"
                        },
                        "uploading": {
                            "description": "Je wordt automatisch doorgestuurd.",
                            "label": "Je foto wordt verwerkt..."
                        }
                    },
                    "update_cart": {
                        "loading": {
                            "description": "Je wordt automatisch doorgestuurd naar de winkelwagen.",
                            "label": "Het product wordt bijgewerkt."
                        }
                    },
                    "force_size_selection_message": "Selecteer eerst een formaat om verder te gaan.",
                    "force_size_selection_tooltip": "Je moet nog een formaat selecteren"
                },
                "product_filters": {
                    "choose_option": "Kies een optie",
                    "make_your_choice": "Maak je keuze"
                },
                "product_set": {
                    "available_sizes_label": "Wijzig je formaten",
                    "discount_label": "Setkorting",
                    "position_label": "Afbeelding {number}",
                    "save_label": "Opslaan",
                    "standard_sizes_note": "Afbeeldingen zijn op basis van standaard formaten"
                },
                "switch_options": {
                    "with_name": "Met naam",
                    "without_name": "Zonder naam"
                }
            },
            "user_text": {
                "error": {
                    "empty": "Geen tekst ingevuld"
                },
                "label": "Persoonlijke tekst",
                "placeholder": "Voer uw tekst in..."
            },
            "price": {
                "from_abbreviation": "v.a.",
                "instead_of": "anders"
            },
            "after_upload_text": "Daarna: kies formaat en bekijk prijzen",
            "timer": {
                "label": "Nog {days} dagen en {hours}:{minutes}:{seconds}",
                "last_day_label": "Nog maar {hours} uur en {minutes}:{seconds}",
                "one_day_label": "Nog {days} dag en {hours}:{minutes}:{seconds}"
            },
            "ai_upload": {
                "history": {
                    "loading_previous": "Jouw vorige versie wordt ingeladen",
                    "loading_latest": "Jouw nieuwste versie wordt ingeladen"
                },
                "auth": {
                    "email": {
                        "continue": "Doorgaan",
                        "context": "Vul je e-mailadres in om je eigen foto te uploaden en te laten genereren met AI.",
                        "error": "Er is iets misgegaan. Probeer het opnieuw.",
                        "placeholder": "Jouw e-mailadres",
                        "title": "Doorgaan"
                    },
                    "login": {
                        "context": "Er bestaat al een account met {email}. Log in om verder te gaan.",
                        "forgot_password": "Wachtwoord vergeten?",
                        "general_error": "Inloggen is mislukt. Controleer je gegevens en probeer opnieuw.",
                        "password_placeholder": "Vul je wachtwoord in",
                        "submit": "Inloggen",
                        "title": "Inloggen"
                    },
                    "otp": {
                        "general_error": "Er is iets misgegaan. Probeer het opnieuw.",
                        "intro": "We hebben een verificatiecode gestuurd naar {email}.",
                        "resend": "Geen code ontvangen? Opnieuw versturen",
                        "resend_sent": "We hebben een nieuwe code gestuurd.",
                        "submit": "Bevestig en foto kiezen",
                        "title": "Bevestig je e-mailadres",
                        "submit_continue": "Bevestig"
                    },
                    "success": {
                        "cta": "Selecteer je foto",
                        "title": "Ingelogd!"
                    }
                },
                "ai_generated_badge": "AI gegenereerd",
                "view_full_screen": "Bekijk de foto op volledig scherm",
                "button": {
                    "label": "Begin met bestellen",
                    "choose_photo": "Kies je foto",
                    "try_again": "Opnieuw proberen",
                    "offline": "Je bent offline. Het uploaden gaat automatisch verder zodra je verbinding hersteld is.",
                    "slow_connection": "Je hebt een trage verbinding. Het uploaden kan wat langer duren.",
                    "add_text": "Naam/tekst toevoegen",
                    "edit_text": "Naam/tekst bewerken",
                    "errors": {
                        "invalid_file_type": "Dit bestandstype wordt niet ondersteund. Upload een foto in JPG-, PNG- of WEBP-formaat.",
                        "file_too_small": "Dit bestand is te klein. Kies een andere foto.",
                        "file_too_large": "Dit bestand is te groot. Upload een foto van maximaal 100 MB."
                    }
                },
                "progress": {
                    "retry": "Probeer opnieuw",
                    "retry_different_photo": "Upload een andere foto",
                    "beauty_shots_failed": "Helaas konden we je productafbeeldingen niet aanmaken. Probeer het opnieuw.",
                    "image_failed": "Deze productafbeelding kon niet worden gemaakt.",
                    "overtime": "Dit duurt iets langer dan verwacht. We gaan door, nog even geduld.",
                    "shot_pending": "Deze productfoto wordt nog gemaakt. De andere kun je al bekijken.",
                    "creating_previews": "We maken nu je productvoorbeelden...",
                    "title": "Jouw afbeelding wordt gemaakt",
                    "subtitle": "Gemiddeld 60-90 seconden. Even geduld a.u.b.",
                    "baking_title": "We maken nieuwe productfoto's voor jou",
                    "bake_progress_title": "Nieuwe productfoto's worden geladen",
                    "bake_progress_subtitle": "Op basis van jouw naam worden nieuwe productfoto's gemaakt.",
                    "preparing_photo_error": "Het voorbereiden van je productfoto is niet gelukt. Probeer het opnieuw.",
                    "preparing_photo_and_cart_title": "We voegen je product toe aan je winkelwagen",
                    "preparing_photo_and_cart_description": "Ondertussen ronden we je persoonlijke productfoto af.",
                    "beauty_shots_count": "{completed} van {total}",
                    "steps": {
                        "analyzing": "Foto analyseren",
                        "recognizing": "Gezicht herkennen",
                        "styling": "Stijl toepassen",
                        "finalizing": "Design finaliseren",
                        "creating_images": "Afbeeldingen maken",
                        "uploading": "Jouw foto verwerken",
                        "generating": "Afbeelding maken",
                        "processing": "Afbeelding afwerken",
                        "processing_plural": "Afbeeldingen afwerken",
                        "previews": "Productfoto's aanmaken",
                        "preview_single": "Je productfoto wordt gemaakt",
                        "preview_plural": "Je productfoto's worden gemaakt",
                        "uploading_busy": "Dit duurt iets langer dan verwacht...",
                        "analyzing_busy": "We kijken goed naar je foto...",
                        "generating_busy": "Je afbeelding wordt gemaakt...",
                        "generating_busy_plural": "Je afbeeldingen worden gemaakt...",
                        "processing_busy": "Laatste bewerkingen...",
                        "previews_busy": "De productfoto's worden aangemaakt, nog even...",
                        "baking_style": "Tekst & stijl verwerken",
                        "baking_text": "Tekst op foto plaatsen",
                        "baking_text_subtitle": "Je tekst wordt op de afbeelding gezet.",
                        "baking_photo": "Productfoto bijwerken",
                        "addition_activating": "{label} stijl laden",
                        "addition_transforming": "Voorbeeld omvormen",
                        "addition_transforming_subtitle": "We verwerken de afbeelding",
                        "addition_generating": "{label} genereren",
                        "addition_finalizing": "Details afwerken",
                        "uploading_subtitle": "We maken je foto klaar voor de AI",
                        "analyzing_subtitle": "We kijken wat er op je foto staat",
                        "generating_subtitle": "De AI maakt je eigen afbeelding",
                        "generating_subtitle_plural": "De AI maakt je eigen afbeeldingen",
                        "processing_subtitle": "We werken de laatste details af",
                        "addition_activating_subtitle": "We laden de stijl die je koos",
                        "uploading_done": "Foto verwerkt",
                        "analyzing_done": "Foto geanalyseerd",
                        "generating_done": "Afbeelding gemaakt",
                        "generating_done_plural": "Afbeeldingen gemaakt",
                        "processing_done": "Details afgewerkt",
                        "addition_activating_done": "Stijl geladen",
                        "addition_transforming_done": "Voorbeeld klaar"
                    }
                },
                "regenerate": {
                    "title": "Opnieuw genereren",
                    "feedback_placeholder": "\"Meer gelijkend\" of \"Levendiger kleuren\"",
                    "with_feedback": "Met feedback",
                    "error_generic": "Er ging iets mis. Probeer het opnieuw.",
                    "threshold_exceeded": "De dagelijkse limiet voor AI-fotogeneratie is bereikt. Probeer het morgen opnieuw.",
                    "style_additions_generate": "Voorbeeld met {label}",
                    "style_additions_cost_notice": "Je gebruikt 1 AI credit",
                    "style_additions_title": "Toevoeging kiezen"
                },
                "personalization": {
                    "title": "Tekst toevoegen",
                    "title_update": "Naam/tekst toevoegen",
                    "field_label": "Naam/tekst",
                    "cta_add": "Toevoegen",
                    "cta_edit": "Bewerken",
                    "edit_baked_text": "Tekst aanpassen",
                    "edit_baked_notice": "Je tekst staat nu in de afbeelding. Pas je hem aan, dan maken we de foto’s opnieuw met je nieuwe tekst.",
                    "preview_mode": "Voorbeeldmodus – nog niet gegenereerd",
                    "add_text": "Nieuwe tekst",
                    "generating": "Genereren...",
                    "committed_hint": "Verwijder een tekst om terug te keren naar het originele voorbeeld.",
                    "text_placeholder": "Jouw naam",
                    "font_label": "Lettertype",
                    "size_label": "Grootte",
                    "color_label": "Tekstkleur",
                    "background_padding_label": "Opvulling",
                    "mode_text": "Tekst",
                    "remove": "Tekst verwijderen",
                    "drag_hint": "Sleep om te verplaatsen",
                    "update_preview": "Opslaan en voorbeeld bekijken",
                    "alignment_label": "Uitlijning",
                    "weight_label": "Dikte",
                    "reset_text": "Tekst herstellen",
                    "remove_text": "Tekst verwijderen",
                    "remove_all_text": "Opnieuw beginnen",
                    "weight_300": "Dun",
                    "weight_400": "Normaal",
                    "weight_500": "Medium",
                    "weight_600": "Halfvet",
                    "weight_700": "Vet",
                    "weight_800": "Dikgedrukt",
                    "weight_900": "Zwaar",
                    "uncommitted_modal_title": "Tekst nog niet opgeslagen",
                    "uncommitted_modal_body": "Je hebt tekst toegevoegd maar deze is nog niet opgeslagen in jouw ontwerp.",
                    "uncommitted_add_without_text": "Bestellen zonder tekst",
                    "uncommitted_generate": "Genereren en controleren",
                    "uncommitted_cancel": "Doorgaan met aanpassen",
                    "active_banner": "Andere foto's geblokkeerd",
                    "view_photos": "Bekijk alle foto's",
                    "active_banner_tooltip": "Je bent in personalisatiemodus. Klap de personalisatie in om de andere foto's weer te bekijken, of genereer een voorbeeld (stap 2).",
                    "uncommitted_generate_and_add": "Opslaan en in winkelwagen",
                    "uncommitted_next_product_options": "Daarna kies je je productopties.",
                    "uncommitted_next_redirect_to_cart": "Daarna word je doorgestuurd naar de winkelwagen.",
                    "mobile_save": "Opslaan",
                    "text_done": "Tekst opslaan"
                },
                "crop": {
                    "panel_title": "Selecteer je gezicht",
                    "panel_description": "Gebruik het selectievak om je gezicht goed te kadreren. Zo krijg je het beste resultaat.",
                    "image_load_error": "We konden je foto niet laden. Probeer een andere afbeelding.",
                    "zoom_in": "Inzoomen",
                    "zoom_out": "Uitzoomen",
                    "validating": "Foto valideren…",
                    "error_title": "Dat is niet gelukt"
                },
                "validation": {
                    "retry": "Andere foto kiezen",
                    "cancel": "Annuleren",
                    "no_face": {
                        "title": "Gezicht niet herkend",
                        "description": "We konden geen duidelijk gezicht herkennen in je selectie. Verplaats het selectievak naar het gezicht, of upload een andere foto.",
                        "tip_1": "Kijk recht in de camera.",
                        "tip_2": "Zorg voor goede belichting — vermijd tegenlicht.",
                        "tip_3": "Verwijder zonnebrillen, maskers of petten."
                    },
                    "no_pet": {
                        "title": "Geen huisdier herkend",
                        "description": "We konden geen huisdier herkennen in je foto. Upload een foto waarop je huisdier goed zichtbaar is."
                    },
                    "mismatch": {
                        "title": "Geen persoon herkend",
                        "description": "We konden geen persoon herkennen in je selectie. Verplaats het selectievak naar het gezicht, of upload een andere foto.",
                        "tip_1": "Verplaats het selectievak zodat het gezicht in beeld staat.",
                        "tip_2": "Of upload een foto waarop de persoon duidelijk te zien is."
                    },
                    "unsafe": {
                        "title": "Foto niet geaccepteerd",
                        "description": "Je foto voldoet niet aan onze richtlijnen. Upload een andere foto.",
                        "tip_1": "Gebruik een geschikte, neutrale portretfoto."
                    },
                    "unavailable": {
                        "title": "Fotocontrole niet beschikbaar",
                        "description": "De fotocontrole is tijdelijk niet beschikbaar. Je foto is gewoon doorgestuurd.",
                        "tip_1": "Probeer het later opnieuw als je problemen ondervindt."
                    }
                },
                "daily_limit_reached": "AI-fotogeneratie is tijdelijk niet beschikbaar. Probeer het morgen opnieuw.",
                "user_daily_limit_reached": "Je hebt je AI-generatielimiet bereikt. Probeer het over 1 uur opnieuw. | Je hebt je AI-generatielimiet bereikt. Probeer het over {count} uur opnieuw.",
                "cycle_limit_reached_with_previous_title": "Je hebt al je credits gebruikt",
                "cycle_limit_go_back": "← Bekijk vorige resultaten",
                "related_styles": {
                    "title": "AI stijlen"
                },
                "view_previous_generations": "Bekijk eerdere afbeeldingen",
                "transfer": {
                    "title": "Gebruik je vorige foto",
                    "dismiss": "Gebruik een andere foto",
                    "generate": "Maak mijn ontwerp",
                    "photo_label": "Jouw foto",
                    "change": "Wijzig foto"
                },
                "beauty_shots_generating": "Nog {count} productfoto wordt aangemaakt... | Nog {count} productfoto's worden aangemaakt...",
                "user_limit_reached_unknown_wait": "Je hebt je AI-generatielimiet bereikt. Probeer het later opnieuw.",
                "status": {
                    "loading": {
                        "label": "Je foto wordt geüpload",
                        "description": "Daarna word je automatisch doorgestuurd."
                    },
                    "offline": {
                        "title": "Geen verbinding",
                        "description": "Je verbinding is weggevallen. Zodra je weer online bent, gaan we verder waar we gebleven zijn."
                    },
                    "errors": {
                        "title": "Upload mislukt",
                        "generic": "Er is iets misgegaan tijdens het uploaden. Probeer het opnieuw.",
                        "retry_cta": "Probeer opnieuw"
                    }
                }
            }
        },
        "product_options": {
            "preview_alt": "Voorbeeld",
            "saved_price": "Je bespaart {amount}",
            "title": "Overzicht van je product",
            "preview_loading": "Voorbeeld wordt ingeladen...",
            "update_cart": "Winkelwagen bijwerken"
        },
        "tools": {
            "add_to_cart_error": {
                "description": "Je product kon niet worden toegevoegd aan de winkelwagen. Geen zorgen — je configuratie is veilig opgeslagen.",
                "retry": "Probeer opnieuw",
                "title": "Oeps, er is iets misgegaan"
            },
            "ai": {
                "crop": {
                    "title": "Bijsnijden",
                    "sidebar": "Bijsnijden"
                },
                "select": {
                    "title": "Kiezen",
                    "heading": "Kies je favoriet",
                    "description": "Kies de variant die je het mooist vindt.",
                    "candidate_label": "Variant {number}",
                    "name_placeholder": "Jouw naam",
                    "candidate_pending": "Deze variant wordt nog gemaakt…",
                    "candidate_failed": "Deze variant kon niet gemaakt worden.",
                    "candidate_retry": "Probeer opnieuw",
                    "candidate_selected": "Geselecteerd",
                    "select_candidate": "Kies variant {number}",
                    "view_larger": "Bekijk variant {number} groter",
                    "choose_this": "Kies deze",
                    "show_all": "Toon al mijn afbeeldingen",
                    "limit_reached": "Je hebt je generatielimiet bereikt. Kies uit de afbeeldingen die je al hebt.",
                    "regenerate_question": "Niet tevreden?",
                    "regenerate": "Maak twee nieuwe",
                    "regenerating": "Nog twee worden gegenereerd…",
                    "regenerate_error": "We konden geen extra afbeeldingen genereren. Probeer het later opnieuw.",
                    "save_error": "We konden je keuze niet opslaan. Probeer het opnieuw."
                },
                "configurator": {
                    "title": "Personaliseren",
                    "sidebar": "Tekst",
                    "panel_title": "Voeg je tekst toe",
                    "name_required_hint": "Vul je eigen naam in om verder te gaan.",
                    "view_preview_button": "Voorbeeld bekijken",
                    "preparing": {
                        "loading": {
                            "label": "We maken je productfoto",
                            "description": "Een moment…"
                        }
                    }
                },
                "preview": {
                    "title": "Voorbeeld",
                    "shot_pending": "Deze afbeelding wordt nog gemaakt…",
                    "shot_failed": "Deze afbeelding kon niet gemaakt worden.",
                    "retry_shot": "Probeer opnieuw",
                    "go_to_shot": "Ga naar afbeelding {number}",
                    "previous_shot": "Vorige afbeelding",
                    "next_shot": "Volgende afbeelding",
                    "view_larger": "Bekijk afbeelding {number} groter",
                    "filling": "Foto’s worden gemaakt"
                }
            },
            "mediaclip": {
                "configurator": {
                    "choose_size": {
                        "label": "Kies je formaat"
                    },
                    "custom_size": {
                        "label": "Kies een eigen formaat"
                    },
                    "title": "Configurator"
                }
            },
            "product_options": {
                "title": "Product opties"
            }
        },
        "success_page": {
            "banner": {
                "title": "Geplaatst!",
                "sub_title": "Bedankt voor je bestelling. We gaan gelijk aan de slag."
            },
            "title": "Wat nu?",
            "steps": {
                "order_confirmation": {
                    "title": "Orderbevestiging",
                    "description": "We sturen je een orderbevestiging (<strong>#{orderNumber}</strong>) naar je e-mailadres. Je vindt al je bestellingen in je account.",
                    "description_fallback": "We sturen je een orderbevestiging naar je e-mailadres. Je vindt al je bestellingen in je account.",
                    "summary": {
                        "total_paid": "Totaal betaald (incl. btw)",
                        "total_in_email": "Het betaalde bedrag vind je in je orderbevestiging.",
                        "show": "Bekijk je bestelling",
                        "hide": "Verberg je bestelling",
                        "discount": "Korting",
                        "discount_code": "Kortingscode {code}",
                        "shipping": "Verzendkosten",
                        "free": "Gratis",
                        "payment_fee": "Transactiekosten",
                        "other": "Overig",
                        "total": "Totaal"
                    }
                },
                "shipping_confirmation": {
                    "title": "Verzendbevestiging",
                    "description": "Je ontvangt een e-mail zodra je producten zijn ingepakt en overhandigd aan de bezorgdienst.",
                    "delivery_date": "Wordt bezorgd op"
                },
                "delivery_address": {
                    "title": "Bezorgadres",
                    "description": "Jouw artikel(en) worden bezorgd op",
                    "info": "Niet thuis? Je pakket wordt afgegeven bij de buren of een afhaalpunt."
                },
                "questions": {
                    "title": "Vragen?",
                    "description": "We helpen je graag! Neem een kijkje op onze",
                    "customer_service_link": "klantenservicepagina",
                    "show_the_wow": {
                        "title": "Laat de WOW zien!",
                        "description": "Laat je vrienden zien wat je voor jezelf hebt besteld!",
                        "instagram_label": "Instagram",
                        "facebook_label": "Facebook"
                    },
                    "news_letter": {
                        "label": "Exclusief",
                        "title": "Word jij ook WOW-lid?",
                        "usp_1": "10% korting op je volgende bestelling",
                        "usp_2": "Nieuwe ontwerpen en producten als eerste ontdekken",
                        "usp_3": "Exclusieve kortingscodes & acties",
                        "button": "Lid worden"
                    }
                }
            },
            "page_title": "Bestelling geplaatst!"
        },
        "checkout_page": {
            "form": {
                "delivery": {
                    "available_from": "Beschikbaar op",
                    "choose_pickup_location": "Kies je afhaalpunt",
                    "day_after_tomorrow_delivery": "Vandaag besteld, <b>overmorgen</b> in huis!",
                    "deliver_at_pickup_location": "Selecteer een afhaalpunt",
                    "latest_delivery": "Je pakket wordt uiterlijk bij je thuis bezorgd op",
                    "no_address": "Voer je bezorgadres in om de beschikbare verzendmethodes te zien.",
                    "no_pickup_locations": "Geen afhaalpunten gevonden",
                    "opening_times": {
                        "label": "Openingstijden"
                    },
                    "postal_code_search": {
                        "button": "Zoeken",
                        "label": "Postcode",
                        "placeholder": "Voer een postcode in"
                    },
                    "selected_pickup_location": "Geselecteerd afhaalpunt:",
                    "show_on_map": "Weergeven op kaart",
                    "show_other_pickup_locations": "Bekijk meer afhaalpunten",
                    "tabs": {
                        "delivery": "Bezorgen",
                        "pickup": "Afhaalpunt"
                    },
                    "tomorrow_delivery": "Vandaag besteld, <b>morgen</b> in huis!",
                    "error": "Er is iets misgegaan bij het laden van de bezorgopties."
                },
                "payment": {
                    "no_address": "Voer je bezorgadres in om de beschikbare betaalmethodes te zien.",
                    "no_payment_required": "Geen betaling vereist.",
                    "no_payment_required_subtitle": "Je bestelling wordt volledig gedekt door je kortingscode."
                }
            },
            "free": "Gratis",
            "messages": {
                "errors": {
                    "billing_address_missing": "Je factuuradres is niet compleet. Controleer je adres en probeer het opnieuw.",
                    "placing_order_failed": "Je bestelling kan op dit moment niet worden geplaatst.",
                    "shipping_address_missing": "Je bezorgadres is niet compleet. Controleer je adres en probeer het opnieuw."
                }
            },
            "overview": {
                "place_order_button": {
                    "label": "Plaats bestelling"
                },
                "prices": {
                    "discount": "Korting",
                    "shipping_costs": "Verzendkosten",
                    "shipping_surcharge": "Toeslag",
                    "payment_fee": "Betaalkosten",
                    "subtotal": "Subtotaal",
                    "total": "Totaal",
                    "you_save": "Je bespaart",
                    "coupon_code": "Kortingscode",
                    "incl_vat": "incl. {amount} btw",
                    "promotion_discount": "Actiekorting"
                },
                "quote_items": {
                    "count": "1 artikel | {count} artikelen",
                    "quantity": "Aantal: {quantity}"
                },
                "title": "Overzicht"
            },
            "payment": {
                "most_popular": "Meest gekozen"
            }
        },
        "configurator": {
            "sizes": {
                "most_chosen": "Meest gekozen"
            }
        },
        "search": {
            "title": "Zoekresultaten",
            "title_with_query": "Zoekresultaten voor ‘{query}’",
            "products_title": "Producten",
            "heading_all": "Alle designs",
            "heading_with_query": "Zoekresultaten voor ‘{query}’",
            "heading_no_results": "Geen resultaten voor ‘{query}’",
            "subtitle_no_results": "Controleer de spelling of probeer een algemener zoekwoord.",
            "browse_by_product_title": "Bekijk per product"
        }
    },
    "slices": {
        "algolia_slider": {
            "price": {
                "else": "anders",
                "from": "vanaf"
            }
        },
        "plp_before_after": {
            "before": "Voor",
            "after": "Na"
        },
        "plp_customer_images": {
            "image_alt": "Klantfoto"
        },
        "pdp_before_after": {
            "before": "Voor",
            "after": "Na"
        },
        "contact_form_business": {
            "gift_timing_placeholder": "Wanneer wil je de koffers cadeau geven?*",
            "referral_placeholder": "Hoe heb je over ons gehoord?*",
            "no_options": "Geen opties beschikbaar",
            "selected_file": "Geselecteerd bestand:",
            "required_fields": "Vul alle verplichte velden in.",
            "submit_error": "Er is een fout opgetreden bij het verzenden van het formulier. Probeer het opnieuw.",
            "invalid_file_type": "Ongeldig bestandstype. Alleen JPEG, PNG, GIF, BMP, WEBP of SVG zijn toegestaan."
        },
        "banner_slider": {
            "excellent": "Uitstekend"
        }
    },
    "tools": {
        "mediaclip": {
            "configurator": {
                "designer": {
                    "loading": "We bereiden de configurator voor."
                },
                "footer": {
                    "buttons": {
                        "cancel": {
                            "label": "Annuleren"
                        },
                        "change_size": {
                            "label": "Wijzig formaat ({size})"
                        },
                        "choose_size": {
                            "label": "Kies formaat"
                        },
                        "to_photo": {
                            "label": "Naar foto {number}"
                        }
                    }
                },
                "project_title": {
                    "error": "Opslaan mislukt",
                    "label": "Titel",
                    "placeholder": "Geef je project een naam...",
                    "saved": "Opgeslagen",
                    "saving": "Opslaan..."
                },
                "hexagon_photos_required_modal": {
                    "title": "Foto's ontbreken",
                    "description": "Foto's {list} zijn nog niet ingevuld. Klik op een leeg vakje, upload je foto en probeer daarna opnieuw.",
                    "letter_collage_description": "Nog niet alle vakjes hebben een foto. Klik op een leeg vakje, upload je foto en probeer daarna opnieuw.",
                    "close": "Begrepen"
                },
                "connection_lost_modal": {
                    "title": "Verbinding verbroken",
                    "description": "We kunnen je ontwerp even niet bereiken. Controleer je internetverbinding en herlaad de pagina; je ontwerp wordt automatisch bewaard.",
                    "reload": "Pagina herladen"
                }
            }
        },
        "landscape_popup": {
            "text": "Deze pagina werkt beter als je het scherm draait. Draai je scherm om door te gaan met je bestelling."
        }
    }
}
